module.exports = __webpack_public_path__ + "img/amx-2.7162a312.jpg";